<script setup>

import axios from 'axios';
import { ref } from 'vue';

const state = ref("Loading...");
const toggle = ref(false);
const secondKpsState = ref("");

async function load(){
    var response = await axios.get("/api/ykb-kps/checkState" + window.location.search); 
    if(response.data.success){
        state.value = "InCall";
    }
    else
    {
        secondKpsState.value = response.data.error;
        toggle.value = true;
    }
}

async function clicked () {
    var response = await axios.get("/api/ykb-kps/closePage" + window.location.search); 
    if(!response.data.success && !toggle.value)
    {
        state.value = "Cant close still In Call";
    }
    else
    {
        window.close();
    }
}

load();
</script>

<template>
    <div class="state">
        {{ state }}
    </div>
    <div class="mockButtonDiv">
        <v-btn class="bg-success" @click="clicked">
            {{ $t("Close") }}
        </v-btn>
    </div>
    <div class="secondKps" v-show="toggle" style="justify-content: center; align-items: center;">
        {{ secondKpsState }}
    </div>
</template>

<style>

</style>